/* global axios */
import ApiClient from './ApiClient';

export const SUGGESTION_POLLING_TIMEOUT = 'suggestion_polling_timeout';

const wait = delay =>
  new Promise(resolve => {
    setTimeout(resolve, delay);
  });

class AiAgentSuggestionsAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  suggest(conversationId) {
    return axios.post(`${this.url}/${conversationId}/ai_agent_suggestion`);
  }

  async suggestUntilReady(
    conversationId,
    { interval = 2000, maxAttempts = 60, shouldContinue = () => true } = {}
  ) {
    const poll = async attempt => {
      const response = await this.suggest(conversationId);
      if (!shouldContinue()) return null;
      if (response.data?.status !== 'processing') return response;

      if (attempt >= maxAttempts - 1) {
        const error = new Error(SUGGESTION_POLLING_TIMEOUT);
        error.code = SUGGESTION_POLLING_TIMEOUT;
        throw error;
      }

      await wait(interval);
      return poll(attempt + 1);
    };

    return poll(0);
  }
}

export default new AiAgentSuggestionsAPI();
